import React from "react";

type PropsDef = {
  size?: number;
};

/**
 * The one icon for every resource: the tabler/golf flag (decision Q7). The
 * Resources page cards, the bay column headers of the facility calendar and
 * the calendar view menu use it.
 */
export default function ResourceIcon({ size = 20 }: PropsDef) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <path d="M12 18V3l7 4l-7 4" />
      <path d="M9 17.67c-.62.36-1 .82-1 1.33c0 1.1 1.8 2 4 2s4-.9 4-2c0-.5-.38-.97-1-1.33" />
    </svg>
  );
}
